import { Icon } from 'components/atoms/Icon'
import type { ContactsProps } from './types'
import { Section } from 'components/organisms/Section'
import {
  Button,
  EButtonStyleVariant,
  EButtonVariant,
} from 'components/atoms/Button'

import './index.scss'

const mainClass = 'contacts'

export const Contacts = ({
  title,
  subtitle,
  note,
  action,
  list = [],
}: ContactsProps) => {
  if (!list.length) {
    return null
  }

  return (
    <Section
      id="_contacts"
      className={mainClass}
      title={title}
      subtitle={subtitle}
      note={note}
      action={action}
    >
      {list.map((item) => (
        <Button
          key={item.id}
          href={item.href}
          variant={EButtonVariant.LINK}
          buttonVariant={EButtonStyleVariant.SECONDARY}
          className={`${mainClass}__link`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name={item.icon} className={`${mainClass}__link-icon`} />
          {item.text}
        </Button>
      ))}
    </Section>
  )
}
